import { initSubRoutes } from '../../utils/router';

const RoutesPubliquesDonneesPersonnelles = initSubRoutes({
    route: '/donnees-personnelles',
    subroutes: {},
    nom: 'Données personnelles',
});

export default RoutesPubliquesDonneesPersonnelles;
